import { render, staticRenderFns } from "./regularSaleSubmenu.vue?vue&type=template&id=79db95fb&"
import script from "./regularSaleSubmenu.vue?vue&type=script&lang=ts&"
export * from "./regularSaleSubmenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports